import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AppRendererComponent} from "./renderer/app.renderer.component";
import {AppEditorComponent} from "./editor/app.editor.component";
import {DataHistoryComponent} from "./editor/data.history.component";
import {JsonEditorComponent} from "./editor/json.editor.component";
import {TreeEditorComponent} from "./editor/tree.editor.component";
import {SamplesComponent} from "./renderer/components/samples.component";

export const HOME_PAGE = 'web-editor.html';
export const PREFIX = HOME_PAGE + '/';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {path: '', redirectTo: HOME_PAGE, pathMatch: 'full'},
            {path: HOME_PAGE, component: AppEditorComponent, pathMatch: 'full'},
            {path: PREFIX + 'app-editor', component: AppEditorComponent, pathMatch: 'full'},
            {path: PREFIX + 'samples', component: SamplesComponent},
            {path: PREFIX + 'tree-editor', component: TreeEditorComponent},
            {path: PREFIX + 'json-editor', component: JsonEditorComponent},
            {path: PREFIX + 'app-renderer', component: AppRendererComponent},
            {path: PREFIX + 'data-history', component: DataHistoryComponent},
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
    ],
})
export class AppRoutingModule {
}
